export const tradePhone = {
  name: "trade-phone" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M5.1 3c0-1.05.85-1.9 1.9-1.9h9c1.05 0 1.9.85 1.9 1.9v5.327l.463-.463a.9.9 0 0 1 1.273 1.272l-2 2a.9.9 0 0 1-1.273 0l-2-2a.9.9 0 1 1 1.273-1.272l.464.463V3a.1.1 0 0 0-.1-.1H7a.1.1 0 0 0-.1.1v17.5a.1.1 0 0 0 .1.1h9a.1.1 0 0 0 .1-.1V14a.9.9 0 1 1 1.8 0v6.5a1.9 1.9 0 0 1-1.9 1.9H7a1.9 1.9 0 0 1-1.9-1.9V3Zm5 16a.9.9 0 0 1 .9-.9h1a.9.9 0 1 1 0 1.8h-1a.9.9 0 0 1-.9-.9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["trade-phone"],
  category: "device" as const,
};
